import React from 'react';

const About = () => {
  return (
    <div className="siteBg">
      <div className="container">
        <div className="d-flex justify-content-between">
          <div className="abouttxt">
            <h2>ABOUT <br />EYE ROLLING UNCLE</h2>
            <p>
            The Eye Rolling Uncle is a collection of 10000 uncles with an attitude to the world. The project is brought by some exhausted big tech employees, who are building a safe place to complain in the metaverse.           
            </p>
          </div>
          <div>
            <img className="uncleimg" src="./imgs/UncleGif.gif" alt=""></img>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div className="collectxt">
            <p>THE COLLECTION</p>
          </div>
          <div className="btnmt">
             <a href="https://opensea.io/collection/eyerollinguncle" className="iconbet" target="_blank" rel = "noopener noreferrer"> 
              <button className="showbtn">SHOW MORE</button>
             </a> 
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            <img className="uncleimg" src="./imgs/Uncle1.png" alt=""></img>
          </div>
          <div>
            <img className="uncleimg" src="./imgs/Uncle2.png" alt=""></img>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            <img className="uncleimg" src="./imgs/Uncle3.png" alt=""></img>
          </div>
          <div>
            <img className="uncleimg" src="./imgs/Uncle4.png" alt=""></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
